/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className: any;
}

export const Zap = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 1.66663L3.41118 10.5732C3.12051 10.922 2.97517 11.0964 2.97295 11.2437C2.97102 11.3717 3.02808 11.4935 3.12768 11.574C3.24226 11.6666 3.46928 11.6666 3.92333 11.6666H9.99997L9.16663 18.3333L16.5888 9.42675C16.8794 9.07794 17.0248 8.90354 17.027 8.75624C17.0289 8.62819 16.9719 8.50637 16.8723 8.42588C16.7577 8.33329 16.5307 8.33329 16.0766 8.33329H9.99997L10.8333 1.66663Z"
        stroke="url(#paint0_linear_2004_838)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10.8333 1.66663L3.41118 10.5732C3.12051 10.922 2.97517 11.0964 2.97295 11.2437C2.97102 11.3717 3.02808 11.4935 3.12768 11.574C3.24226 11.6666 3.46928 11.6666 3.92333 11.6666H9.99997L9.16663 18.3333L16.5888 9.42675C16.8794 9.07794 17.0248 8.90354 17.027 8.75624C17.0289 8.62819 16.9719 8.50637 16.8723 8.42588C16.7577 8.33329 16.5307 8.33329 16.0766 8.33329H9.99997L10.8333 1.66663Z"
        stroke="url(#paint0_linear_2004_838)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.16"
        strokeWidth="1.5"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2004_843"
          x1="-3.44679"
          x2="12.5073"
          y1="10.2401"
          y2="23.6933"
        >
          <stop stopColor="#7549F4" />
          <stop offset="1" stopColor="#FCA6E9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2004_843"
          x1="9.99997"
          x2="9.99997"
          y1="1.66663"
          y2="18.3333"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
